import React, { useEffect, useState } from 'react';
import { getImages } from '../const';
import { Link } from 'react-router-dom';

const DealVaultTable = ({data, numberFormatter, searchText}) => {
    
    const [sortConfig, setSortConfig] = useState({ key: 'dom_is', direction: '' });

    const sortedData = React.useMemo(() => {
        let sortableData = [...data];
    
        if (sortConfig !== null) {
            sortableData.sort((a, b) => {
                let aValue = a[sortConfig.key], bValue = b[sortConfig.key];
    
                if (aValue < bValue) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }

                return 0;
            });
        }
    
        return sortableData;
    }, [data, sortConfig]);
    

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };
    const [expandedRow, setExpandedRow] = useState(null);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };
    const [rowCount, setRowCount] = useState(9);
    const [hideViewMoreBtn, setHideViewMoreBtn] = useState(false);
    const handleViewMoreBtn = () => {
        setRowCount(sortedData.length)
        setHideViewMoreBtn(true)
    }
    return (
        <div className='custom-table avg-retail-table deal-vault-table scrollbar-vertical'>
            <div className='sv-body'>
                <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th
                                className={
                                    sortConfig.key === 'sold_date_ts'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'text-start ps-4 sort-asc'
                                            : 'text-start ps-4 sort-desc'
                                        : 'text-start ps-4'
                                }
                                
                                onClick={() => requestSort('sold_date_ts')}>
                                Date
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'vehicle'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'text-start sort-asc'
                                            : 'text-start sort-desc'
                                        : 'text-start'
                                }
                                
                                onClick={() => requestSort('vehicle')}>
                                Vehicle
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'total'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                }
                                onClick={() => requestSort('total')}
                            >
                                <div className='d-inline-flex align-items-center'>
                                    <span>Purchase <br/>Price</span>
                                    <span className='sort-icon pm-sort-icon ms-3'></span>
                                </div>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'sale_price'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                }
                                onClick={() => requestSort('sale_price')}
                            >
                                <div className='d-inline-flex align-items-center'>
                                    <span>Sales <br/>Price</span>
                                    <span className='sort-icon pm-sort-icon ms-3'></span>
                                </div>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'source'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'text-start sort-asc'
                                            : 'text-start sort-desc'
                                        : 'text-start'
                                }
                                onClick={() => requestSort('source')}
                            >Source Dealer
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'name'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'text-start sort-asc'
                                            : 'text-start sort-desc'
                                        : 'text-start'
                                }
                                onClick={() => requestSort('name')}
                            >
                                Dealer Sold To
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'purchasing_agent'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                }
                                onClick={() => requestSort('purchasing_agent')}
                            >
                                <div className='d-inline-flex align-items-center'>
                                    <span>Purchasing <br/>Agent</span>
                                    <span className='sort-icon pm-sort-icon ms-3'></span>
                                </div>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'salesmen'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                }
                                onClick={() => requestSort('salesmen')}>
                                Salesman
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.filter((item) => !searchText || item.vehicle.toLowerCase().includes(searchText.toLowerCase()) || item.purchasing_agent.toLowerCase().includes(searchText.toLowerCase()) || item.salesmen.toLowerCase().includes(searchText.toLowerCase()) || item.name.toLowerCase().includes(searchText.toLowerCase()) || item.source.toLowerCase().includes(searchText.toLowerCase())).map((v, i) => {
                            const priceDiff = v.price_fs - v.avg_price;
                            return (
                                <tr key={i}>
                                    <td className='text-start'>{v.sold_date}</td>
                                    <td className='text-start'>{v.vehicle}</td>
                                    <td>{numberFormatter(v.purchase_price,true)}</td>
                                    <td>{numberFormatter(v.sale_price,true)}</td>
                                    <td className='text-start'>{v.source}</td>
                                    <td className='text-start'>{v.name}</td>
                                    <td>{v.purchasing_agent}</td>
                                    <td>{v.salesmen}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {/* {!hideViewMoreBtn &&
                <div className='text-center pt-3'>
                    <button type='button' className='red-btn text-uppercase w-206' onClick={handleViewMoreBtn}>View More</button>
                </div>
            } */}
        </div>
    );
};

export default DealVaultTable;
